'use client';

import { c as _c } from "react/compiler-runtime";
export function MiniBar(t0) {
  const $ = _c(5);
  const {
    value,
    max,
    tone: t1
  } = t0;
  const tone = t1 === undefined ? "green" : t1;
  const width = `${Math.max(6, Math.min(100, value / max * 100))}%`;
  const color = tone === "red" ? "bg-[#d6654f]" : tone === "ink" ? "bg-[#251133]" : "bg-[#4ea97e]";
  const t2 = `h-full rounded-full ${color}`;
  let t3;
  if ($[0] !== width) {
    t3 = {
      width
    };
    $[0] = width;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className="h-2 w-full rounded-full bg-[#e8ddca]"><div className={t2} style={t3} /></div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}